/* eslint-disable no-case-declarations */
import initialState from '../initialState';
import {
  ADD_CART_ITEM,
  DECREASE_CART_QUANTITY,
  DELETE_CART_ITEM,
  INCREASE_CART_QUANTITY
} from './actionTypes';

const cartItemReducer = (state = initialState.cartItems, action) => {
  switch (action.type) {
    case ADD_CART_ITEM:
      return [...state, action.payload];
    case DELETE_CART_ITEM:
      return state.filter(item => item.productId !== action.payload);
    case INCREASE_CART_QUANTITY:
      return state.map(item => {
        if (item.productId === action.payload) {
          item.cartQuantity = item.cartQuantity + 1;
          item.remainingQuantity = item.remainingQuantity - 1;
        }
        return item;
      });

    case DECREASE_CART_QUANTITY:
      return state.map(item => {
        if (item.productId === action.payload) {
          item.cartQuantity = item.cartQuantity - 1;
          item.remainingQuantity = item.remainingQuantity + 1;
        }
        return item;
      });
    default:
      return state;
  }
};

export default cartItemReducer;
